import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ListGroup } from 'react-bootstrap';
import { FileUploader } from 'react-drag-drop-files';
import './upload-receipt.scss';

interface UploadReceiptProps {
   file?: File;
   setFile: (file: File) => void;
}

const fileTypes = ['PDF', 'PNG', 'JPG'];

const UploadReceipt: FC<UploadReceiptProps> = ({file, setFile}) => {
   const { t } = useTranslation(['common']);

   const handleChange = (selectedFile: File) => {
      setFile(selectedFile);
   };

   return (
      <div className="upload-receipt">
         <FileUploader
            handleChange={handleChange}
            name="file"
            types={fileTypes}
            multiple={false}
            label={t('common:settings.uploadOrDropInvoice')}
            uploadedLabel={t('common:settings.uploadSuccessChangeInvoice')}
            classes="file-uploader"
         />

         {file && (
            <ListGroup className="mt-2 list-size">
               <ListGroup.Item className="d-flex justify-content-between align-items-center">
                  {file.name}
                  <span className="badge bg-primary">
                     {(file.size / 1024).toFixed(2)} KB
                  </span>
               </ListGroup.Item>
            </ListGroup>
         )}
      </div>
   );
};

export default UploadReceipt;